:host {
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
}

:host > .z-list-group-header-container {
  color: var(--gray700);
  font-size: var(--font-size-2);
  font-weight: var(--font-sb) !important;
  letter-spacing: 0.16px;
  line-height: 1.4;
}

:host > .z-list-group-header-container.has-header {
  padding-top: var(--space-unit);
  padding-bottom: var(--space-unit);
}

:host > .z-list-group-header-container.has-header > z-divider {
  margin-top: var(--space-unit);
}

:host > .grouped-tree-list-header {
  padding-top: var(--space-unit);
  padding-bottom: 0;
}
